import request from '@/utils/request';
import axios from 'axios';
import envs from '@/envs';

//상품목록
export function getGoodsOrderList(data) {
	//테스트 임시
	return request({
		url: '/order/getOrderGoodsList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//sms인증번호발송
export function sendUserCallbackSmsVerification(data) {
	return request({
		url: '/authMobile/sendUserCallbackSmsVerification',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//sms인증번호체크
export function sendUserCallbackSmsConfirm(data) {
	return request({
		url: '/authMobile/sendUserCallbackSmsConfirm',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//발신번호목록조회
export function getSendingNumberList(data) {
	return request({
		url: '/userCallback/orderList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//발신번호등록
export function addMobileNo(data) {
	return request({
		url: '/userCallback/addMobileNo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//메세지 목록
export function getMessageList(data) {
	return request({
		url: '/mybiz/getMyMessageList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//biz추천 상용구 메세지 목록
export function getRecommendMessageList(data) {
	return request({
		url: '/mybiz/getBizMessageList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//메세지 저장
export function addMessage(data) {
	return request({
		url: '/mybiz/addMyMessage',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//배너 카드 템플릿 아이디 유효성 체크
export function getSafetyTemplate(data) {
	return request({
		url: '/order/validation/templateIds',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//배너카드 기본 이미지 불러오기
export function getBannerCardDefault(data) {
	return request({
		url: '/mybiz/getDefaultImageList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//배너카드 카테고리 목록 조회
export function getBannerCardCategoryList(data) {
	return request({
		url: '/mybiz/getMmsCategoryList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//배너카드 이미지 목록 조회
export function getBannerCardImageList(data) {
	return request({
		url: '/mybiz/getTemplateList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//배너카드 이미지 저장
export function addBannerCardImage(data) {
	// return request({
	//   url: '/mybiz/addImage',
	//   method: 'post',
	//   headers: { 'Content-Type': 'application/json'},
	//   data
	// })
	// 인증서버 url이 다를 경우 여기를 변경한다.
	var baseUrl = envs.buildUrl;
	if (process.env.NODE_ENV === 'development') {
		baseUrl = envs.devUrl;
	}

	return axios.post(baseUrl + '/mybiz/addImage', data);
	// http://61.74.201.250:8080/FO.API/api/user/add
}

//배너카드 삭제
export function deleteImage(data) {
	return request({
		url: '/mybiz/deleteImage',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//임시저장 (일반주문)
export function addTempOrder(data) {
	return request({
		url: '/order/addTempOrder',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//임시저장 재주문 조회 (일반주문)
export function getOrderTempOrder(data) {
	return request({
		url: '/v2/order/getOrderTempOrder',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//결제페이지 이동전 체크사항
export function payPossible(data) {
	return request({
		url: '/v2/order/payPossible',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//주문하기
export function addOrder(data) {
	return request({
		url: '/order/addOrder',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
export function addOrderByBasicTemplate(data) {
	return request({
		url: '/order/addOrder/basicTemplate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//주문 완료페이지 (일반결제 + 비즈창고결제)
export function getOrderResult(data) {
	return request({
		url: '/v2/order/getOrderResult',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//비즈머니 조회
export function searchBizPoint(data) {
	return request({
		url: '/bizPoint/searchBizPoint',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//가상계좌 사용여부
export function getUsedVirtualAccount(data) {
	return request({
		url: '/user/getUsedVirtualAccount',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//비즈충전API
export function addBizmoneyOrder(data) {
	return request({
		url: '/order/addBizmoneyOrder',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//비즈충전API
export function getVirtualAccountWaitingExist(data) {
	return request({
		url: '/order/getVirtualAccountWaitingExist',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//비즈머니 당일 계좌 충전금액
export function searchBizPointTodayChg(data) {
	return request({
		url: '/order/searchBizPointTodayChg',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 알림톡 발신프로필 목록 조회
export function retvProfUuid(data) {
	return request({
		url: '/talkOrder/talkProfUuidList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// // 선택한 발신프로필에 해당하는 마이템플릿 목록 조회
// export function getMyTmpltList(data) {
//   return request({
//     url: "/talkOrder/talkProfTmpltList",
//     method: "post",
//     headers: { "Content-Type": "application/json" },
//     data
//   });
// }

// 선택한 발신프로필에 해당하는 공통템플릿 목록 조회
export function getComTmpltList(data) {
	return request({
		url: '/talkOrder/talkProfTmpltList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 발신프로필, 템플릿 상태 조회
export function getProfTmpltStatus(data) {
	return request({
		url: '/talkOrder/talkStatus',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//공휴일 목록
export function getHolidayList(data) {
	//테스트 임시
	return request({
		url: '/order/getHolidayList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 발신목적 리스트 조회
export function getPurposeList(data) {
	return request({
		url: '/order/purposeSending',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 비즈할인권 핀번호 조회
export function getBizGiftCardPossible(data) {
	return request({
		url: `/order/bizGiftCardPossible`,
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
